



































import {
  defineComponent,
  ref,
  Ref,
  watch,
  onMounted
} from "@vue/composition-api";
import LocationModel from "@/ts/models/locationClass";

export default defineComponent({
  name: "LocationInput",

  props: {
    value: Object
  },

  setup(props, { emit }) {
    var adress = ref({});
    var selected = ref(false);
    var loading = ref(false);
    var query = ref("");
    var results = ref([]);
    var fetching = ref(false);
    var lastInput = Date.now();
    const delay = 1000;

    onMounted(() => {
      if (props.value) {
        selected.value = true;
        adress.value = props.value;
      }
    });

    const geocode = (value: string): any => {
      fetch(
        `https://geocode.search.hereapi.com/v1/geocode?q=${value}&apiKey=gj95wnWgipY419UbMT8cB15ETPR9EoeRjtsTxfR53mA`
      )
        .then((result: any) => result.json())
        .then((result: any) => {
          results.value = result.items;
          loading.value = false;
        });
    };

    watch(
      () => query.value,
      (value: any) => {
        if (value) {
          loading.value = true;

          lastInput = Date.now();

          setTimeout(() => {
            if (Date.now() - lastInput > delay - 20) {
              geocode(value);
            }
          }, delay);
        } else {
          results.value = [];
        }
      }
    );

    const reset = () => {
      selected.value = false;
      query.value = "";
      adress.value = {};
      emit("input", null);
    };

    const onChange = (value: any) => {
      if (typeof value === "object") {
        selected.value = true;
        const newLocation = new LocationModel(value);
        adress.value = newLocation;
        emit("input", newLocation);
      }
    };

    return {
      query,
      results,
      loading,
      adress,
      onChange,
      selected,
      reset
    };
  }
});
